import { t } from './i18n.js';

/**
 * Helpers de exibição de voucher (cientes de locale) compartilhados por toda
 * superfície que mostra vouchers (linha do tempo da viagem, bancada).
 * Formatação pura — sem IO, sem estado.
 */

// Moeda NÃO segue o locale da UI: formato brasileiro fixo, moeda do backend.
// (datas seguem o idioma — ver `formatDateRange` abaixo.) Lifted verbatim para
// `@voll-intelligence/trip-document` na Task 3 — mesma conta, agora
// compartilhada com a lane de PDF.
export { money } from '@voll-intelligence/trip-document';

export function modalLabel(modal: string): string {
  switch (modal) {
    case 'FLIGHT':
      return t('home.service.flight.label');
    case 'HOTEL':
      return t('home.service.hotel.label');
    case 'BUS':
      return t('home.service.bus.label');
    case 'RENTAL':
      return t('home.service.rental.label');
    case 'MOBILITY':
      return t('home.service.mobility.label');
    default:
      return modal;
  }
}
